module.exports = __webpack_public_path__ + "img/save-black.941f9a90.svg";